import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useAbort = (options) => {
    const { api_key } = useSettings();
    const { language, cart } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-abort'], queryFn: async ({ signal }) => {
            var _a;
            let url = new URL(`/consumer/checkout/${api_key}/abort`, ConfigHolder.apiBaseUrl);
            url.searchParams.set('api_lang', language);
            const data = {
                saleId: (_a = cart.order_id) !== null && _a !== void 0 ? _a : ""
            };
            let body = new URLSearchParams(data);
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST", // this request is GET in the old widget
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/ld+json',
                },
                body: body
            });
            return response.json();
        } }));
};
